import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link, 
  Divider 
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[200]
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              关于我们
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Destiny-Crystal是一家专注于AI算命和手串销售的电商平台，为您提供最专业的命理解读和最优质的水晶手串产品。
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              快速链接
            </Typography>
            <Link component={RouterLink} to="/" color="inherit" display="block" sx={{ mb: 1 }}>
              首页
            </Link>
            <Link component={RouterLink} to="/shop" color="inherit" display="block" sx={{ mb: 1 }}>
              全部商品
            </Link>
            <Link component={RouterLink} to="/ai-fortune" color="inherit" display="block" sx={{ mb: 1 }}>
              AI算命
            </Link>
            <Link component={RouterLink} to="/fortune-teller" color="inherit" display="block" sx={{ mb: 1 }}>
              预约命理师
            </Link>
            <Link component={RouterLink} to="/fortune-guide" color="inherit" display="block" sx={{ mb: 1 }}>
              命理知识
            </Link>
            <Link component={RouterLink} to="/crystal-guide" color="inherit" display="block" sx={{ mb: 1 }}>
              水晶百科
            </Link>
            <Link component={RouterLink} to="/faq" color="inherit" display="block" sx={{ mb: 1 }}>
              常见问题
            </Link>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              关于我们
            </Link>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              使用条款
            </Link>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              隐私政策
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              联系我们
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              邮箱: dylan@martha-trade.com
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              电话: +65 91761341
            </Typography>
            <Typography variant="body2" color="text.secondary">
              地址: 10 MARINA BOULEVARD #39 MARINA BAY FINANCIAL CENTRE SINGAPORE (018983)
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" color="text.secondary" align="center">
          {'© '}
          {new Date().getFullYear()}
          {' MARTHA TRADE PTE. LTD. 保留所有权利。'}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;